import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from 'atoms/Button/Button';
import MoveIcon from 'images/v5/icons/copy-07.svg';
import EditSvg from 'images/v5/icons/edit-02.svg';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import { openModal } from 'store/layoutSlice';
import { setCurrentFolder } from 'store/specificationsMoveSlice';
function FolderOptions({ id, name, parentId }) {
    const { t } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const handleEdit = () => {
        dispatch(openModal({ name: 'folderEditor', data: { id, name } }));
    };
    const handleMove = () => {
        dispatch(setCurrentFolder({ folderId: id }));
        dispatch(openModal({ name: 'moveFolder', data: { id } }));
    };
    const handleDelete = () => {
        dispatch(openModal({ name: 'removeFolder', data: { id, name, parentId } }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(EditSvg, null), onClick: handleEdit }, t('edit')),
        React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(MoveIcon, null), onClick: handleMove }, t('move')),
        React.createElement("hr", null),
        React.createElement(Button, { align: "left", theme: "ghost", color: "danger", leftIcon: React.createElement(TrashSvg, null), onClick: handleDelete }, t('delete'))));
}
export default FolderOptions;
